module.exports = __webpack_public_path__ + "img/open-eye.149ecd6f.svg";